/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDim1DiagLeftIcon24Solid = forwardRef('ArrowDim1DiagLeftIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M10.5 1.625a1.375 1.375 0 1 1 0 2.75H6.32L19.625 17.68V13.5a1.375 1.375 0 1 1 2.75 0v6.25a2.625 2.625 0 0 1-2.625 2.625H13.5a1.375 1.375 0 1 1 0-2.75h4.18L4.375 6.32v4.18a1.375 1.375 0 1 1-2.75 0V4.25A2.625 2.625 0 0 1 4.25 1.625h6.25Z" })));
});
